// extracted by mini-css-extract-plugin
export var icon = "Label-module--icon--3a0qc";
export var icon_black = "Label-module--icon_black--Jb5ip";
export var icon_white = "Label-module--icon_white--lMhTq";
export var label = "Label-module--label--zThid";
export var label_black = "Label-module--label_black--7z23R";
export var label_white = "Label-module--label_white--mri5J";